<template>
  <div class="header-details rpi-header-details">
        <b-row>
      <b-col xs="12" sm="6">
        <static-form-control
          id="PONumber"
          :label-text="getContentItem('poNumber')"
          :value="data.DealerPurchaseOrder"
          :cols="3"
        />
      </b-col>
      <b-col xs="12" sm="3">
        <static-form-control
          id="ShipmentType"
          :label-text="getContentItem('Type')"
          :value="data.ShipmentType"
          :cols="5"
        />
      </b-col>
      <b-col xs="12" sm="3">
        <static-form-control
          id="FreightTerm"
          :label-text="getContentItem('freightTerms')"
          :value="data.FreightTerm"
          :cols="5"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col xs="12" sm="6">
        <static-form-control
          id="ShipVia"
          :label-text="getContentItem('shipVia')"
          :value="data.shipViaHtml"
          :cols="3"
        />
      </b-col>
      <b-col v-if="data.orderedByHtml.length > 0" xs="12" sm="3">
        <static-form-control
          id="OrderedBy"
          :label-text="getContentItem('OrderedBy')"
          :value="data.orderedByHtml"
          :cols="5"
        />
      </b-col>
      <b-col v-if="data.PartsStoreCustomerNumber" xs="12" sm="3">
        <static-form-control
          id="PartsStoreCustomerNumber"
          :label-text="getContentItem('partsStoreCode')"
          :value="data.PartsStoreCustomerNumber"
          :cols="5"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { StaticFormControl } from "@/components/Elements";
  import { formatDateTime } from "@/components/mixins/formatDateTime";

  export default {
    name: "RpiHeaderDetails",
    components: {
      StaticFormControl
    },
    mixins: [formatDateTime],
    props: {
      data: Object
    },
    computed: {
      ...mapGetters(["getContentItem"])
    }
  };
</script>
